import React, { FC } from 'react';
import { Category } from 'shared/types/product';
import ProductTile from 'components/commercetools-ui/molecules/product-tile';
import { Product } from 'types/entity/product';
import { TieredPriceData } from 'frontastic/tastics/products/details';
import { useProductList } from '../../context';
import { getMatchingVariant } from '../../helpers';

interface ProductTileWrapperProps {
  product: Product;
  isSearchResult?: boolean;
  onClick?: () => void;
  index?: number;
  tileCTA?: string;
  categories?: Category[];
  config?: Record<string, string>;
  textConfig?: Record<string, string>;
  tieredPrice?: TieredPriceData[];
  calendarOptions?: any;
  ffid?: string;
  showCategory?: boolean;
  isFavoritePage?: boolean;
  isToggleP2r?:boolean;
}

const PlpProductTileWrapper: FC<ProductTileWrapperProps> = ({
  product,
  isSearchResult,
  onClick,
  index,
  tileCTA,
  categories,
  config,
  textConfig,
  tieredPrice,
  calendarOptions,
  ffid,
  showCategory = false,
  isFavoritePage = false,
  isToggleP2r
}) => {
  const { searchQuery } = useProductList();
  const { wishlist, shippingMethods, addToWishlist, removeFromWishlist, onAddToCart } = useProductList();

  const selectedColorVariantIndex = getMatchingVariant(product.variants, searchQuery, isSearchResult);

  return (
    <ProductTile
      product={product}
      wishlist={wishlist}
      shippingMethods={shippingMethods}
      selectedVariantIndex={selectedColorVariantIndex}
      isSearchResult={isSearchResult}
      onClick={onClick}
      addToWishlist={addToWishlist}
      removeLineItem={removeFromWishlist}
      onAddToCart={onAddToCart}
      index={index}
      tileCTA={tileCTA}
      categories={categories}
      config={config}
      textConfig={textConfig}
      tieredPrice={tieredPrice}
      calendarOptions={calendarOptions}
      ffid={ffid}
      showCategory={showCategory}
      isFavoritePage={isFavoritePage}
      isToggleP2r={isToggleP2r}
    />
  );
};

export default PlpProductTileWrapper;
